/* ZO•ON storefront features (Sept 2026) – see snippets/zoon-features.liquid */
(function () {
  'use strict';
  var Z = window.ZOON || {};
  var T = Z.t || {};
  var root = Z.root || '';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function fmtISK(cents) {
    var n = Math.round(cents / 100);
    var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return Z.en ? s.replace(/\./g, ',') + ' ISK' : s + ' kr.';
  }
  function safeStore(get, key, val) {
    try { if (get) return JSON.parse(localStorage.getItem(key) || '[]'); localStorage.setItem(key, JSON.stringify(val)); } catch (e) { return []; }
  }

  /* 1. Product page trust list under the add-to-bag area */
  function trust() {
    var tpl = document.getElementById('zoon-trust-tpl');
    var form = document.querySelector('.product__form-container');
    if (!tpl || !form || document.querySelector('.product__information .zoon-trust')) return;
    form.parentNode.insertBefore(tpl.content.cloneNode(true), form.nextSibling);
  }

  /* 2. Sticky buy bar on phones */
  function stickyBuy() {
    var bar = document.getElementById('zoon-sticky-buy');
    var btn = document.querySelector('.product__form-container .product-form__add-to-cart');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    if (btn.disabled) { bar.parentNode.removeChild(bar); return; }
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    });
    io.observe(btn);
    bar.querySelector('[data-zoon-scroll-to-form]').addEventListener('click', function () {
      var target = document.querySelector('.product__form-container') || btn;
      var y = target.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  /* 3. Recently viewed */
  function recentlyViewed() {
    if (Z.template !== 'product' || !Z.productHandle) return;
    var key = 'zoon_recently_viewed';
    var list = safeStore(true, key) || [];
    var others = list.filter(function (h) { return h !== Z.productHandle; }).slice(0, 4);
    list = [Z.productHandle].concat(list.filter(function (h) { return h !== Z.productHandle; })).slice(0, 12);
    safeStore(false, key, list);
    if (!others.length || !window.fetch) return;
    Promise.all(others.map(function (h) {
      return fetch(root + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(function (p) { return p && p.available !== undefined; });
      if (!items.length) return;
      var wrap = document.createElement('section');
      wrap.className = 'zoon-rv container';
      var html = '<h2 class="zoon-rv__title">' + T.recentlyViewed + '</h2><ul class="zoon-rv__grid">';
      items.forEach(function (p) {
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_500x$1$2') : '';
        html += '<li class="zoon-rv__item"><a href="' + root + '/products/' + p.handle + '">' +
          (img ? '<span class="zoon-rv__img"><img loading="lazy" src="' + img + '" alt=""></span>' : '') +
          '<span class="zoon-rv__name">' + String(p.title).replace(/</g, '&lt;') + '</span>' +
          '<span class="zoon-rv__price">' + fmtISK(p.price) + '</span></a></li>';
      });
      wrap.innerHTML = html + '</ul>';
      var main = document.getElementById('MainContent');
      if (main) main.appendChild(wrap);
    });
  }

  /* 4. Free-shipping progress in the side cart */
  function freeShipping() {
    var summary = document.querySelector('.side-cart__summary');
    if (!summary || !window.fetch) return;
    var box = document.createElement('div');
    box.className = 'zoon-ship';
    box.innerHTML = '<p class="zoon-ship__text"></p><div class="zoon-ship__track"><span class="zoon-ship__fill"></span></div>';
    summary.insertBefore(box, summary.firstChild);
    var text = box.querySelector('.zoon-ship__text');
    var fill = box.querySelector('.zoon-ship__fill');
    var goal = Z.freeShippingCents || 1000000;
    var busy = false;
    function update() {
      if (busy) return; busy = true;
      fetch(root + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        busy = false;
        var total = cart.total_price || 0;
        box.style.display = cart.item_count ? '' : 'none';
        var pct = Math.min(100, Math.round(total / goal * 100));
        fill.style.width = pct + '%';
        box.classList.toggle('is-done', total >= goal);
        text.textContent = total >= goal ? T.freeShipDone : T.freeShipLeft.replace('{amount}', fmtISK(goal - total));
      }).catch(function () { busy = false; });
    }
    update();
    var count = document.getElementById('cart-items');
    var side = document.querySelector('.side-cart');
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { setTimeout(update, 250); });
      if (count) mo.observe(count, { childList: true, characterData: true, subtree: true });
      if (side) mo.observe(side, { attributes: true, attributeFilter: ['class'] });
      var sub = document.getElementById('side-cart__subtotal');
      if (sub) mo.observe(sub, { childList: true, characterData: true, subtree: true });
    }
  }

  /* 5. NEW badges + 6. hover image on product cards */
  function cards(scope) {
    var newSet = {};
    (Z.newHandles || []).forEach(function (h) { newSet[h] = true; });
    var hover = Z.hoverImages || {};
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 900px)').matches;
    (scope || document).querySelectorAll('.product-item[data-product]').forEach(function (li) {
      if (li.getAttribute('data-zoon-done')) return;
      li.setAttribute('data-zoon-done', '1');
      var h = li.getAttribute('data-product');
      var link = li.querySelector('.product-item__image');
      if (!link) return;
      var sale = link.querySelector('.sale-badge');
      if (sale && T.saleBadge) sale.textContent = T.saleBadge;
      var info = li.querySelector('.product-item__info');
      if (newSet[h] && !sale && info && !info.querySelector('.zoon-new-label')) {
        var b = document.createElement('span');
        b.className = 'zoon-new-label';
        b.textContent = T.newBadge;
        info.insertBefore(b, info.firstChild);
      }
      if (canHover && hover[h]) {
        var first = link.querySelector('img');
        var file = hover[h].split('?')[0].split('/').pop().replace(/_630x806.*$/, '');
        if (first && (first.getAttribute('src') || '').indexOf(file.split('.')[0]) !== -1) return;
        var img = document.createElement('img');
        img.className = 'zoon-hover-img';
        img.loading = 'lazy';
        img.alt = '';
        img.src = hover[h];
        link.classList.add('zoon-has-hover');
        link.appendChild(img);
      }
    });
  }


  /* 7. Icelandic labels for leftover English theme text (IS storefront only) */
  function translateLeftovers() {
    if (Z.en) return;
    var map = { 'Quick View': 'Skoða', 'QUICK BUY': 'KAUPA', 'LOAD MORE': 'SJÁ MEIRA', 'Sold Out': 'Uppselt',
      'REVIEWS': 'UMSAGNIR', 'Filter Options': 'Sía', 'Sort By': 'Raða eftir', 'View All': 'Sjá allt', 'You May Also Like': 'Þér gæti líka líkað' };
    var walker = document.createTreeWalker(document.getElementById('MainContent') || document.body, NodeFilter.SHOW_TEXT, null);
    var n, hits = [];
    while ((n = walker.nextNode())) {
      var k = n.nodeValue.trim();
      if (map[k]) hits.push(n);
    }
    hits.forEach(function (node) { node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), map[node.nodeValue.trim()]); });
  }

  /* 8. Product count under the collection title */
  function productCount() {
    if (Z.template !== 'collection' || !Z.productCount) return;
    var title = document.querySelector('.collection__hero .collection__title');
    if (!title || document.querySelector('.zoon-count')) return;
    var c = document.createElement('span');
    c.className = 'zoon-count';
    c.textContent = Z.productCount + ' ' + (Z.productCount === 1 ? T.product1 : T.products);
    title.parentNode.insertBefore(c, title.nextSibling);
  }

  ready(function () {
    try { trust(); } catch (e) {}
    try { stickyBuy(); } catch (e) {}
    try { recentlyViewed(); } catch (e) {}
    try { freeShipping(); } catch (e) {}
    try { cards(); } catch (e) {}
    try { translateLeftovers(); } catch (e) {}
    try { productCount(); } catch (e) {}
    /* cards added later (sliders, filters) */
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { try { cards(); translateLeftovers(); } catch (e) {} }, 300); })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  });
})();